import React from 'react';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

const DeleteMenu = ({ onDeleteClick }) => {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        backgroundColor: '#fee2e2',
        padding: '6px',
        marginLeft: '8px',
        cursor: 'pointer',
        boxShadow: '0 2px 6px rgba(216, 54, 54, 0.3)',
        transition: 'background-color 0.3s ease',
      }}
      title="Delete"
      onClick={onDeleteClick}
      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#faceceff'}
      onMouseLeave={e => e.currentTarget.style.backgroundColor = '#fee2e2dd'}
    >
      <DeleteOutlineOutlinedIcon fontSize="small" sx={{ color: '#dc2626' }} />
    </span>
  );
};

export default DeleteMenu;
